import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useEffect, useRef } from "react";
import { useCountUp } from "react-countup";
import { useResizeDetector } from "react-resize-detector";
export const VideoFrameCount = /*#__PURE__*/ memo((param)=>{
    let { currentTime, frameCount, totalTime } = param;
    const countRef = useRef(null);
    const { ref: resizeRef, width } = useResizeDetector({
        handleHeight: false
    });
    const { update } = useCountUp({
        ref: countRef,
        duration: 0.5,
        end: frameCount || 0
    });
    useEffect(()=>{
        update(Math.floor(currentTime / totalTime * frameCount));
    }, [
        currentTime,
        frameCount,
        totalTime,
        update
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex items-center gap-1 text-14 text-grey-11",
        "data-testid": "VIDEO_FRAME_COUNT",
        style: {
            fontFeatureSettings: "'tnum' on"
        },
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: "text-right font-medium text-grey-12",
                "data-testid": "VIDEO_FRAME_COUNT_CURRENT",
                ref: countRef,
                style: {
                    minWidth: width
                }
            }),
            /*#__PURE__*/ _jsx("span", {
                children: "/"
            }),
            /*#__PURE__*/ _jsx("span", {
                "data-testid": "VIDEO_FRAME_COUNT_TOTAL",
                ref: resizeRef,
                children: frameCount ? frameCount.toLocaleString() : "-"
            })
        ]
    });
});
VideoFrameCount.displayName = "VideoFrameCount";
